import React from 'react';
import * as S from './styles';

export default function ActionButton(props) {
  return <S.ActionButton {...props} />;
}
